export default function AboutPage() {
  return (
    <div className="pt-32 pb-24 bg-white dark:bg-slate-950">
      <div className="max-w-[1200px] mx-auto px-6 lg:px-10 space-y-16">
        <header>
          <div className="text-xs uppercase tracking-[0.4em] text-[#D4AF37] font-semibold">About Your Trips</div>
          <h1 className="mt-3 text-5xl sm:text-6xl font-bold text-blue-950 dark:text-white">Journeys, artfully composed.</h1>
          <p className="mt-6 text-lg text-slate-600 dark:text-slate-300 max-w-3xl">Founded in New Delhi, Your Trips is a boutique travel atelier crafting bespoke journeys across India and beyond. We believe travel should feel effortless — a curated symphony of great stays, real stories, and small delights that add up to a lifetime memory.</p>
        </header>
        <section className="grid md:grid-cols-3 gap-6">
          {[
            { t: "Mission", d: "To design journeys so seamless our travellers only remember the joy — never the logistics." },
            { t: "Vision", d: "Become India's most-loved boutique travel brand by 2030 — one story, one sunset at a time." },
            { t: "Values", d: "Warm hospitality, uncompromising quality, and honest pricing. Always." },
          ].map((x) => (
            <div key={x.t} className="rounded-3xl p-8 bg-slate-50 dark:bg-slate-900 border border-slate-200/70 dark:border-white/10">
              <div className="text-xs uppercase tracking-widest text-[#D4AF37]">{x.t}</div>
              <p className="mt-4 text-blue-950 dark:text-white text-lg leading-relaxed">{x.d}</p>
            </div>
          ))}
        </section>
        <section className="grid md:grid-cols-2 gap-10 items-center">
          <img src="https://images.pexels.com/photos/34053333/pexels-photo-34053333.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940" alt="" className="rounded-3xl shadow-xl w-full h-[420px] object-cover"/>
          <div>
            <h2 className="text-3xl font-bold text-blue-950 dark:text-white">Why choose us</h2>
            <ul className="mt-6 space-y-4 text-slate-600 dark:text-slate-300">
              {["Personal concierge for every booking","4★/5★ vetted properties","Private guides & transfers","Best-price guarantee","Transparent inclusions & no surprises","24×7 on-trip WhatsApp support"].map(x =>
                <li key={x} className="flex gap-3"><span className="w-1.5 h-1.5 rounded-full bg-[#D4AF37] mt-2"/> {x}</li>
              )}
            </ul>
          </div>
        </section>
      </div>
    </div>
  );
}
